import React from 'react'

const GlobalContext = React.createContext({
  user: {},
  programs: [],
  total_messages: 0,
})

export default GlobalContext
